import {
  Component,
  Inject,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { TgrServiceService } from '../../../service/tgr-service.service';
import { Tgr } from '../../../interface/tgr';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import Swal from 'sweetalert2';
import { TgrFormDetalleComponent } from '../../forms/tgr-form/tgr-form-detalle/tgr-form-detalle.component';

@Component({
  selector: 'app-detalle-tgr',
  templateUrl: './detalle-tgr.component.html',
  styleUrls: ['./detalle-tgr.component.scss'],
})
export class DetalleTgrComponent {
  @ViewChild(MatSort, { static: true }) sort: MatSort = Object.create(null);
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator = Object.create(null);
  @Input() formularioTGR: string = "";
  public dataSource: MatTableDataSource<Tgr>;
  public displayedColumns: string[] = ['amount', 'date', 'agreement'];
  public tgrSummary:Tgr;
  public rutString: number;
  public mostrarCerrar: boolean = true;
  public tgrDebtUrl: SafeResourceUrl;
  public companyId: number;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DetalleTgrComponent>,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private tgrService: TgrServiceService,
    private sanitizer: DomSanitizer
  ) {
    this.convertirRut(this.data);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['formularioTGR'].currentValue == 'true') {
      this.mostrarCerrar = false;
    }
  }

  cerrarDialogo() {
    this.dialogRef.close();
  }

  convertirRut(rut: any) {
    if (typeof rut === 'string') {
      var miIdCompany;
      const cleanedRutWithoutDots = rut.replace(/\./g, '');
      miIdCompany = parseInt(
        cleanedRutWithoutDots.substring(0, cleanedRutWithoutDots.length - 1)
      );
      this.consltarTgr(miIdCompany);
    }

    if (typeof rut === 'number') {
      this.consltarTgr(rut);
      this.companyId = rut;
    }
  }

  consltarTgr(companyId: number) {
    this.tgrService.getTgr(companyId).subscribe({
      next: (next) => {
        if(next.length > 0){
          console.log("TGR-DATOS: ", next);
          this.tgrSummary = next[0];
          var dateString = this.tgrSummary.date.toLocaleString("yyyy-MM-dd").split("T")[0];
          let Url = "https://docs.google.com/gview?url=https://ingeappstorageprd.blob.core.windows.net/tgr/"+companyId+"_"+dateString+".pdf&embedded=true"
          this.tgrDebtUrl = this.sanitizer.bypassSecurityTrustResourceUrl(Url);
        }
      },
    });
  }

  updateTGR(){
    Swal.fire({
      title: 'Actualizando TGR',
      text: 'Este proceso puede demorar unos minutos, proximamente estará disponible la información.',
      icon: 'info',
      showConfirmButton: false,
      showCloseButton: true,
      didOpen: () => {
        Swal.showLoading();
      }
    })
    this.tgrService.newTgr(this.data).subscribe({
      next: (next) => {
        setTimeout(() => {
          location.reload();
        }, 2 * 60 * 1000);
      },
      error: (error) => {
      Swal.fire({
        title: 'Error',
        text: 'Ha ocurrido un error al actualizar la información.',
        icon: 'error'
      });
      }
    });
  }

  abrirDetalleTgr() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.width = '70vw';
    dialogConfig.height = '64vh';
    dialogConfig.maxWidth = '70vw';
    dialogConfig.maxHeight = '64vh';
    dialogConfig.data = this.companyId;
    const dialogRef = this.dialog.open(TgrFormDetalleComponent, dialogConfig);
  }

  private setDataSource(dataSource: Array<Tgr>) {
    this.dataSource = new MatTableDataSource<Tgr>(dataSource);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
}
